'use client';

import { FfbbsiteGlobals, FfbbsiteNavigation, FfbbsitePartners } from '@/lib/directus';
import { DirectusResponse } from '@/lib/repositories';
import { createContext, PropsWithChildren } from 'react';

export type Data = {
  navigation: DirectusResponse<FfbbsiteNavigation[]>;
  partner: DirectusResponse<FfbbsitePartners[]>;
  global: DirectusResponse<FfbbsiteGlobals>;
};

export const CommonDataContext = createContext<Data | null>(null);

export default function CommonDataProvider({
  children,
  value,
}: PropsWithChildren<{ value: Data }>) {
  return <CommonDataContext.Provider value={value}>{children}</CommonDataContext.Provider>;
}
